import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ElementRef} from "@angular/core";
import {NgClass} from "@angular/common";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-tab-head',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ds-tab-head.component.html',
    styleUrls: ['./ds-tab-head.component.scss'],
    imports: [
        NgClass
    ]
})
export class DsTabHeadComponent {

  @Input() tabId: string;
  @Input() activeTabId: string;
  @Input() hideTab?: boolean;
  @Input() blackStyle?: boolean;
  @Input() size?: string;
  @Input() withBorder?: boolean;
  @Input() inline: boolean = false;
  @Output() onTabHeadClick: EventEmitter<{tabId: string}>;

  constructor(public elementRef: ElementRef) {
    this.onTabHeadClick = new EventEmitter<{tabId: string}>();
  }

  public onClick(): void {
    this.onTabHeadClick.emit({
      tabId: this.tabId
    });
  }

}
